/**
 * Vóór wie mag ik verlof invoeren?
 *
 * De server bepaalt de scope (AD-4): HR/admin krijgen iedereen, een
 * leidinggevende de eigen teamleden, en wie niemand aanstuurt een lege
 * lijst. De UI verbergt haar ingang op basis van die lege lijst — er is
 * dus geen rolcheck aan de clientkant nodig, en er kan er ook geen uit de
 * pas gaan lopen met de server.
 */

import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';

export const selectableEmployeeKeys = {
  all: ['leave-requests', 'selectable-employees'] as const,
};

export function useSelectableEmployees() {
  return useQuery({
    queryKey: selectableEmployeeKeys.all,
    queryFn: () => verlofApi.getSelectableEmployees(),
    staleTime: 1000 * 60 * 5, // 5 min — teamsamenstelling wijzigt zelden
  });
}
